import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Livrarias.css';
import useSEO from '../../hooks/useSEO';

import img_beitec from '../../assets/BEITEC_LOGO_SF.png';
import img_livraria from '../../assets/livraria_a.jpg';
import { BsArrowRight } from 'react-icons/bs';
import {
  FaBookOpen, FaTags, FaMagic, FaFileExcel,
  FaBalanceScale, FaShieldAlt, FaFlag, FaHandshake,
  FaBoxes, FaClipboardList, FaAddressCard, FaGift, FaChartPie, FaLeaf,
  FaFileInvoiceDollar, FaLaptopCode, FaDesktop, FaCloud, FaMobileAlt, FaUnlockAlt,
  FaBook
} from 'react-icons/fa';

export default function Livrarias() {
  const navigate = useNavigate();

  useSEO(
    'Sistema para Livrarias e Papelarias - Gestão Literária Completa',
    'Conheça a solução BeiTec para Livrarias: controle de consignações de editoras, preenchimento automático de sinopses e base de dados de livros integrada. Nascida no balcão da livraria.'
  );

  const openWhatsApp = () => {
    window.open("https://api.whatsapp.com/send?phone=555195555616", "_blank");
  };

  return (
    <div className="livraria-page">
      {/* Navbar Minimalista */}
      <nav className="liv-navbar">
        <div className="liv-nav-content">
          <img
            src={img_beitec}
            alt="BeiTec Sistemas"
            className="liv-nav-logo"
            onClick={() => navigate('/')}
          />
          <button className="nav-btn" onClick={openWhatsApp}>
            Solicitar Demonstração
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="liv-hero">
        <img src={img_livraria} alt="Fundo Livraria" className="liv-hero-img" />
        <div className="liv-hero-content">
          <div className="liv-badge">Especialista em Livrarias</div>
          <h1 className="liv-hero-title">Onde a Paixão pelos Livros Encontra a <span className="highlight">Eficiência Tecnológica</span></h1>
          <p className="liv-hero-desc">
            Nossa plataforma nasceu dentro de uma livraria real. Entendemos cada detalhe: das sinopses automáticas ao controle cirúrgico de consignações.
          </p>
          <button className="liv-btn-light" onClick={openWhatsApp} style={{ marginTop: '24px' }}>
            Assumir o Controle do Acervo <BsArrowRight style={{ marginLeft: '8px' }} />
          </button>
        </div>
      </header>

      {/* Story Section */}
      <section className="bg-textured" style={{ padding: '100px 24px' }}>
        <div className="liv-section-title" style={{ marginBottom: '0' }}>
          <div className="liv-icon" style={{ margin: '0 auto 20px' }}><FaBook /></div>
          <h2>Nascido entre <span className="highlight">Estantes</span></h2>
          <p style={{ marginTop: '20px', fontSize: '1.3rem', lineHeight: '1.8', maxWidth: '880px', margin: '20px auto 0' }}>
            A BeiTec não é apenas mais um software. Somos o resultado de 12 anos de experiência direta no varejo literário.
            Nosso sistema foi forjado para resolver as dores reais.
          </p>
        </div>
      </section>

      {/* Features Grid Focada nas Livrarias */}
      <section className="liv-features-section">
        <div className="liv-section-title">
          <h2>Ferramentas de <span className="highlight">Alta Performace</span></h2>
          <p>O nível de detalhe técnico que o seu espaço literário estava pedindo há anos.</p>
        </div>

        <div className="liv-grid">

          <div className="liv-card">
            <div className="liv-icon"><FaCloud /></div>
            <h3>Liberdade Total em Nuvem</h3>
            <p>Acesse seu negócio de qualquer lugar do mundo. Seus dados estão criptografados nos servidores mais seguros, garantindo backups automáticos e acesso 24h sem você precisar de servidores físicos na loja.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaMobileAlt /></div>
            <h3>Roda em Qualquer Dispositivo</h3>
            <p>Desktop, Tablet ou Smartphone. Nossa interface se adapta perfeitamente ao hardware que você já possui, permitindo consultar estoque ou realizar acertos literários diretamente do próprio celular nas estantes.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaUnlockAlt /></div>
            <h3>Sem Contrato de Fidelidade</h3>
            <p>Acreditamos na parceria, não no aprisionamento. Na BeiTec você tem total liberdade: sem multas rescisórias ou contratos de fidelidade. Ficamos juntos pela qualidade e pelo resultado que entregamos.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaBookOpen /></div>
            <h3>Colunas Auxiliares Completas</h3>
            <p>Cadastre detalhes que fazem a diferença: Autor, Editora, Ano, Sinopse, Número de Páginas e Peso. Tudo indexado e pronto para busca.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaMagic /></div>
            <h3>Base de Dados Integrada</h3>
            <p>Auto-preenchimento inteligente. Ao ler o código de barras, nosso sistema busca na nuvem os dados do livro, economizando horas de digitação manual.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaFileInvoiceDollar /></div>
            <h3>Integração de Pagamento com Nota Fiscal</h3>
            <p>O sistema vincula automaticamente as transações de pagamento (Cartão/Pix) à nota fiscal eletrônica, garantindo que o seu fluxo de caixa e o fisco caminhem lado a lado sem erros.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaDesktop /></div>
            <h3>Múltiplos Modelos Fiscais</h3>
            <p>Suporte completo para NFe (Vendas/Remessas), NFCe (Frente de Caixa Rápida) e NFSe (Serviços/Eventos). Resolva toda a sua burocracia tributária em um só lugar com extrema agilidade.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaFileExcel /></div>
            <h3>Entradas Ágeis (XML/Excel)</h3>
            <p>Importe notas fiscais de entrada de forma automática via XML ou atualize seu acervo em lote através de planilhas Excel.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaShieldAlt /></div>
            <h3>Alertas Fiscal de Cadastro</h3>
            <p>Evite problemas na emissão de notas fiscais. Nosso assistente identifica e sugere correções automáticas para problemas de tributação (NCM/CST) no cadastro.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaHandshake /></div>
            <h3>Gestão de Consignações</h3>
            <p>Um módulo exclusivo para entrada, acertos e devoluções. Tenha o controle total do que pertence à livraria e o que é consignado das editoras.</p>
          </div>


          <div className="liv-card">
            <div className="liv-icon"><FaTags /></div>
            <h3>Criador de Etiquetas</h3>
            <p>Crie e imprima etiquetas para itens, vitrines e prateleiras diretamente pelo sistema, garantindo clareza para seus leitores.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaBalanceScale /></div>
            <h3>Comparador de Preços e Defasagem</h3>
            <p>Analise seu estoque por quantidade ou valor de venda. Descubra instantaneamente se seus preços estão defasados em relação ao mercado.</p>
          </div>





          <div className="liv-card">
            <div className="liv-icon"><FaBoxes /></div>
            <h3>Encomendas de Clientes</h3>
            <p>Gerencie pedidos especiais. Saiba exatamente quem pediu qual livro e seja notificado quando o título der entrada no estoque.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaFlag /></div>
            <h3>Alertas de Estoque Mínimo</h3>
            <p>Nunca perca uma venda por falta de gôndola. Receba alertas automáticos de reposição para seus títulos mais vendidos.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaClipboardList /></div>
            <h3>Gerenciador de Orçamentos</h3>
            <p>Crie propostas profissionais para escolas e eventos literários em segundos, com validade e reserva de estoque temporária.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaAddressCard /></div>
            <h3>Ficha de Cliente e Crédito</h3>
            <p>Ofereça limites de crédito personalizados para pagamento posterior.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaGift /></div>
            <h3>Vale Presente Rastreável</h3>
            <p>Gere e controle vales presente de forma 100% digital e segura, estimulando a recorrência e novas visitas à sua loja.</p>
          </div>

          <div className="liv-card">
            <div className="liv-icon"><FaChartPie /></div>
            <h3>Relatórios Estratégicos</h3>
            <p>Acompanhe o giro do acervo, as margens por editora e a lucratividade real do seu investimento em cultura.</p>
          </div>



          <div className="liv-card">
            <div className="liv-icon"><FaLaptopCode /></div>
            <h3>Seu E-Commerce em Poucos Cliques</h3>
            <p>Crie sua própria loja online integrada ao estoque físico. Permita que seus leitores comprem pelo site e retirem na loja ou recebam em casa, tudo sincronizado automaticamente com o sistema da loja.</p>
          </div>



        </div>
      </section>

      {/* Final Call To Action */}
      <section className="liv-cta-section">
        <div className="liv-cta-content">
          <h2>Transforme sua Livraria hoje mesmo!</h2>
          <p>Dê um fim na burocracia e dedique seu tempo ao que importa: indicar o próximo grande autor para o seu leitor.</p>
          <button className="liv-btn-light" onClick={openWhatsApp}>
            Falar com um Consultor de Livrarias <BsArrowRight style={{ marginLeft: '8px' }} />
          </button>
        </div>
      </section>

      {/* Footer Minimalista */}
      <footer style={{ padding: '40px 24px', backgroundColor: '#fdfaf6', textAlign: 'center', borderTop: '1px solid #e5e5e5' }}>
        <p style={{ color: '#64748b', fontSize: '0.9rem' }}>&copy; {new Date().getFullYear()} BeiTec ® Sistemas Literários.</p>
      </footer>
    </div>
  );
}
